export const SET_PM_FETCHING = 'SET_PM_FETCHING';
export const SET_PM_CONFIG = 'SET_PM_CONFIG';
export const SET_PM_CABINIMAGES = 'SET_PM_CABINIMAGES';
export const SET_PM_CART = 'SET_PM_CART';
export const SET_PM_CONSENT = 'SET_PM_CONSENT';
export const SET_PM_DETAIL_IMAGE = 'SET_PM_DETAIL_IMAGE';
export const SET_PM_ORDER = 'SET_PM_ORDER';
export const CLEAR_PM_ORDER = 'CLEAR_PM_ORDER';
export const SET_PM_ORDERS = 'SET_PM_ORDERS';
export const CLEAR_PM = 'CLEAR_PM';